import { render, staticRenderFns } from "./JoinPartners.vue?vue&type=template&id=10e378b2&"
import script from "./JoinPartners.vue?vue&type=script&lang=js&"
export * from "./JoinPartners.vue?vue&type=script&lang=js&"
import style0 from "./JoinPartners.vue?vue&type=style&index=0&id=10e378b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports